




































































import VueOptions from '@utils/VueOptions'
import RequestButton from '@/components/RequestButton'
import ShoppingCartCardView from './ShoppingCartCardView'
import ShoppingCartTableView from './ShoppingCartTableView'
import ShoppingCartDiscountItems from './ShoppingCartDiscountItems'
import VendorListingsCardView from './VendorListingsCardView'

settings =
  name: "CartItems"

  vue:
    props: ['cart', 'lineItems', 'campaign', 'activationPlans', 'actions']
    components: {
      RequestButton,
      ShoppingCartCardView,
      ShoppingCartTableView,
      ShoppingCartDiscountItems,
      VendorListingsCardView,
    }

    data: ->
      display: 'cards'

    computed:
      audienceListinglineItems: -> (@lineItems || []).filter((item) -> !item.is_professional_service && item.ctx?.audience_listing?)
      vendorListingLineItems: -> (@lineItems || []).filter((item) -> item.is_professional_service)

      audienceListingActivationPlans: -> @activationPlans?.filter((plan) -> plan.type is 'audience_listing') || []
      vendorListingActivationPlans: -> @activationPlans?.filter((plan) -> plan.type is 'vendor_listing') || []

      purchaseDiscountActions: ->
        { hiRemovePurchaseDiscountTrigger: @actions.hiRemovePurchaseDiscountTrigger }

      showRefreshCart: ->
        return false
        return false if not @campaign
        for li in @audienceListinglineItems
            return true if dayjs(@campaign.updated_at).isAfter(li.updated_at)

      disableCartProgressBarActions: ->
        progressBars = @getAppSession('progress_bars', [])
        eventsBeingAdded = !!progressBars.find((bar) -> bar.key.includes('add_target_events'))
        eventsBeingRefreshed = !!progressBars.find((bar) -> bar.key.includes('refresh_cart'))
        purchaseInProgress = @cart.purchase_in_progress
        @requestIsPending || eventsBeingAdded || eventsBeingRefreshed || purchaseInProgress

    methods:
      hiToggleDisplay: ->
        @display = if @display is 'cards' then 'table' else 'cards'

export default VueOptions.vue settings
